import { cn } from "@/lib/utils";
import { StatusPill } from "./status-pill";

interface OpportunityCardProps {
  id: string;
  opportunityNumber: string;
  category: string;
  company?: string;
  urgency: string;
  matchScore: number;
  price: number;
  status: "new" | "in_review" | "completed" | "claimed" | "claim_approved" | "claim_rejected";
  isSelected?: boolean;
  onClick?: () => void;
  className?: string;
  complianceFlag?: boolean;
  onsiteFlag?: boolean;
}

export const OpportunityCard = ({
  opportunityNumber,
  category,
  company,
  urgency,
  matchScore,
  price,
  status,
  isSelected,
  onClick,
  className,
  complianceFlag,
  onsiteFlag,
}: OpportunityCardProps) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        "w-full text-left p-6 border bg-card transition-all duration-300",
        "hover:border-accent/40 hover:shadow-[0_0_30px_hsl(var(--accent)/0.06)]",
        isSelected && "border-accent shadow-[0_0_30px_hsl(var(--accent)/0.08)]",
        !isSelected && "border-border",
        className
      )}
    >
      {/* Header */}
      <div className="flex justify-between items-start mb-5">
        <div className="space-y-1">
          <p className="text-micro">{opportunityNumber}</p>
          <div className="flex items-center gap-3">
            <span className="text-body font-medium">{category}</span>
            <StatusPill status={status} />
          </div>
        </div>
      </div>

      {/* Facts Grid */}
      <div className="grid grid-cols-2 gap-4 mb-5">
        {status !== "new" && company && (
          <div>
            <span className="text-micro block mb-1">Unternehmen</span>
            <p className="text-caption">{company}</p>
          </div>
        )}
        {status === "new" && (
          <div>
            <span className="text-micro block mb-1">Unternehmen</span>
            <p className="text-caption text-muted-foreground italic">Vertraulich bis Annahme</p>
          </div>
        )}
        <div>
          <span className="text-micro block mb-1">Dringlichkeit</span>
          <p className="text-caption">{urgency}</p>
        </div>
        <div>
          <span className="text-micro block mb-1">Match</span>
          <p className="text-caption">{matchScore}%</p>
        </div>
        {(complianceFlag || onsiteFlag) && (
          <div className="col-span-2 flex gap-3">
            {complianceFlag && (
              <span className="text-xs px-2 py-1 bg-accent/10 text-accent border border-accent/20">
                Compliance
              </span>
            )}
            {onsiteFlag && (
              <span className="text-xs px-2 py-1 bg-primary/10 text-primary border border-primary/20">
                Vor-Ort
              </span>
            )}
          </div>
        )}
      </div>

      {/* Price Rail */}
      <div className="pt-4 border-t border-border">
        <div className="flex items-center justify-between">
          <span className="text-micro">Anfrage-Zugang</span>
          <span className="price-display text-xl">{price} €</span>
        </div>
      </div>
    </button>
  );
};
